import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux'
import generateStore from './app/store'
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { ProSidebarProvider } from 'react-pro-sidebar';
const store = generateStore()

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <ProSidebarProvider>
      <App />
    </ProSidebarProvider>
    <ToastContainer />
  </Provider>,
  document.getElementById('root')
);


